<template>
    <v-autocomplete outlined label="Origem" v-bind="$attrs" :dense="dense" v-on="$listeners" :items="origin"
        :item-text="itemText" :item-value="itemValue">
        <template v-slot:selection="{ item, index, items }">
            <template v-if="index < 3">
                <v-chip class="ma-1" small>
                    {{ item.name }}
                </v-chip>
            </template>

            <template v-if="index === 3">
                <span class="grey--text text-caption ml-2">
                    (+{{ $attrs.value.length - 3 }} outros)
                </span>
            </template>
        </template>
    </v-autocomplete>
</template>

<script>
export default {
    props: {
        itemText: {
            default() {
                return (val) => `${val.code} - ${val.name}`;
            },
        },

        itemValue: {
            default() {
                return (val) => val;
            },
        },

        dense: {
            default: false,
        },
    },

    data: () => ({
        origin: [
            { code: 'sale', name: 'Venda' },
            { code: 'bill_receivable', name: 'Conta a Receber' },
            { code: 'bill_receivable_group', name: 'Grupo de Recebíveis' },
            { code: 'bill_receivable_credit', name: 'Crédito Recebido' },
            { code: 'bill_payable', name: 'Conta a Pagar' },
            { code: 'custom', name: 'Personalizado' },
            { code: 'transfer', name: 'Transferência' },
        ],
    }),

    created() {
        this.select()
    },

    methods: {
        select() {
           
        },
    },
};
</script>